import { createSelector } from 'reselect';
import api from './api';

const stateConfigSelector = (state) => state.config;

export const selector = createSelector([stateConfigSelector], (config) => {
    return { ...config };
});

const CONFIG_GET_CONFIG_REQUEST = 'CONFIG_GET_CONFIG_REQUEST';
const CONFIG_GET_CONFIG_SUCCESS = 'CONFIG_GET_CONFIG_SUCCESS';
const CONFIG_GET_CONFIG_FAILURE = 'CONFIG_GET_CONFIG_FAILURE';

const initialState = {
};

export const actionCreators = {
    getConfig: () =>
    api({
        types: [CONFIG_GET_CONFIG_REQUEST, CONFIG_GET_CONFIG_SUCCESS, CONFIG_GET_CONFIG_FAILURE],
        uri: `/api/config`,
        config: {
            method: 'GET',
            headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        },
        sendJwtBearer: false,
    }),
};

export const reducer = (state = initialState, action) => {
    switch (action.type) {
        case CONFIG_GET_CONFIG_SUCCESS:
            return { ...state, ...action.response };
        default:
            return { ...state };
    }
};
